<template>
    <div class="companyshow">
        <el-breadcrumb class="Breadcrumb" separator="/">
            <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
            <el-breadcrumb-item>企业秀/职播</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider></el-divider>
        <div class="search">
            <el-row :gutter="24">
                <el-col :span="6" :offset="0">
                    <el-input v-model="search.title" placeholder="请输入视频标题"></el-input>
                </el-col>
                <el-col :span="6" :offset="0">
                    <el-select v-model="search.cateId" filterable clearable placeholder="请选择" style="width: 100%;">
                        <el-option v-for="item in cateIdSelect" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-button type="primary" @click="getListFun(1)" icon="el-icon-search">查询</el-button>
                    <el-button type="primary" @click="openAdd()" icon="el-icon-plus">添加</el-button>
                </el-col>
            </el-row>
        </div>
        <el-divider></el-divider>
        <div class="table">
            <el-table :data="tableData" stripe style="width: 100%">
                <!-- <el-table-column prop="id" label="id">
                </el-table-column> -->
                <el-table-column type="index" label="序号" width="200">
                </el-table-column>
                <el-table-column prop="title" label="视频标题">
                </el-table-column>
                <el-table-column prop="coverURL" label="封面图">
                    <template slot-scope="scope">
                        <el-image style="width: 150px; height: 150px" :src="scope.row.coverURL" fit="contain"></el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="cate" label="分类">
                </el-table-column>
                <el-table-column label="启用/禁用">
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.isUsed" active-color="#13ce66" inactive-color="#ff4949"
                            :disabled="scope.row.canEdit == false" @change="changeDemo(scope.row.id, scope.row.isUsed)">
                        </el-switch>
                    </template>
                </el-table-column>
                <el-table-column prop="createdDate" label="创建时间">
                </el-table-column>
                <el-table-column prop="id" fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button @click="openShow(scope.row.playUrl)" type="text" icon="el-icon-video-play"
                            size="small">预览</el-button>
                        <el-button @click="openEdit(scope.row)" type="text" icon="el-icon-edit" size="small">编辑</el-button>
                        <el-button @click="deleteFun(scope.row.id)" type="text" icon="el-icon-delete"
                            size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--分页-->
        <div class="pagination">
            <el-pagination background @size-change="changSizeFun" @current-change="changpageFun"
                :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum">
            </el-pagination>
        </div>

        <!-- 添加弹窗-->
        <el-dialog :title="popTitle" :visible.sync="pop" class="customClass" width="30%" @close="resetForm('popDialog')"
            :close-on-click-modal="false">
            <el-form :model="formDate" label-width="80px" ref="popDialog" :rules="rule">
                <el-form-item label="标题" prop="title">
                    <el-input placeholder="请输入标题" v-model="formDate.title"></el-input>
                </el-form-item>
                <el-form-item label="分类" prop="cateId">
                    <el-select v-model="formDate.cateId" filterable placeholder="请选择分类" style="width: 100%;">
                        <el-option v-for="item in cateIdSelect" :key="item.id" :label="item.name"
                            :value="parseInt(item.id)">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="封面" prop="coverURL">
                    <el-upload :action="uploadUrl" :headers="upheader" list-type="picture-card" :auto-upload="true"
                        :on-success="iconSuccess" :file-list="formDate.coverURLList" accept="image/jpg,image/jpeg,image/png"
                        :before-upload="iconBeforeUpload">
                        <i slot="default" class="el-icon-upload"></i>
                        <div slot="formDate" slot-scope="{formDate}">
                            <img class="el-upload-list__item-thumbnail" :src="formDate.coverURL" alt="">
                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-delete" @click="iconRemove">
                                    <i class="el-icon-delete"></i>
                                </span>
                            </span>
                        </div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="描述">
                    <el-input placeholder="请输入描述" v-model="formDate.description"></el-input>
                </el-form-item>
                <el-form-item label="视频" v-if="formDate.id == null">
                    <Vod ref="vod"></Vod>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetForm('popDialog')">取 消</el-button>
                <el-button type="primary" @click="submitForm('popDialog')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Vod from '@/components/VodUpload'
export default {
    data() {
        return {
            //加载数据
            cateIdSelect: [],
            pageSize: 10,
            pageNum: 1,
            totalNum: 0,
            search: {
                title: null,
                cateId: null,
                searchDate: null,
            },
            tableData: [],
            pop: false,
            popTitle: null,
            formDate: {

            },
            rule: {
                title: [
                    { required: true, message: '请输入标题', trigger: 'blur' }
                ],
                cateId: [
                    { required: true, message: '请选择分类', trigger: 'change' }
                ],
            },
            loding: null,
            player: null,
        }
    },
    components: {
        Vod
    },
    mounted() {
        this.getList();
        this.getSelect();
    },
    methods: {
        //查询列表
        getList() {
            let data = {
                title: this.search.title,
                cateId:this.search.cateId,
                pageSize: this.pageSize,
                pageNum: this.pageNum,
            }
            this.$get(api + "/companyShow/getList", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.tableData = res.data;
                    this.totalNum = res.totalNum
                }
            })
        },
        getSelect() {
            let data = {}
            //学历
            this.$get(api + "/companyShow/getSelectCompany", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.cateIdSelect = res.data;
                }
            })
        },
        openAdd() {
            this.formDate = {}
            this.popTitle = "添加企业秀"
            this.pop = true;
        },
        openEdit(ojb) {
            this.formDate = {
                id: ojb.id,
                title: ojb.title,
                cateId: ojb.cateId,
                description: ojb.description,
                videoId: ojb.videoId,
                coverURL: ojb.coverURL,
                coverURLList: [{
                    uid: ojb.coverURL,
                    url: ojb.coverURL
                }]
            }
            this.uploadUrl = api + '/main/companyShowVideo/upload'
            this.upheader = { "token": this.$store.state.userInfo.token }
            this.popTitle = "编辑企业秀"
            this.pop = true;
        },
        openShow(url) {
            this.$router.push({
                path: '/player',
                query: { url }
            });
        },
        openLoding(val) {
            if (!this.loding) {
                const loading = this.$loading({
                    lock: true,
                    text: val,
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.loding = loading;
            }
        },
        closeLoding() {
            if (this.loding) {
                this.loding.close()
                this.loding = null;
            }
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (this.formDate.id) {
                        this.editFun();
                    } else {
                        this.addFun();
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.pop = false;
        },
        addFun() {
            let videoId = this.$refs.vod.getVoidId();
            if (!videoId) {
                this.$message.error("视频未上传");
                return;
            }
            let data = {
                title: this.formDate.title,
                cateId: this.formDate.cateId,
                description: this.formDate.description,
                videoId: videoId,
                coverURL:this.formDate.coverURL,
            }
            this.$post(api + "/companyShow/addShow", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: '添加成功!'
                    })
                    this.closeLoding();
                    this.pop = false;
                    this.getListFun(1);
                } else if (res.code == 1) {
                    this.openLoding(res.desc);
                    setTimeout(() => {
                        this.addFun();
                    }, 5000);
                } else {
                    this.closeLoding();
                    this.$message.error(res.desc);
                }
            })
        },
        editFun() {
            let data = {
                id: this.formDate.id,
                cateId: this.formDate.cateId,
                description: this.formDate.description,
                videoId: this.formDate.videoId,
                coverURL:this.formDate.coverURL,
            }
            this.$post(api + "/companyShow/editShow", data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.$message({
                        type: 'success',
                        message: '修改成功!'
                    });
                    this.pop = false;
                    this.getListFun(this.pageNum);
                } else {
                    this.$message.error(res.desc);
                }
            })
        },
        //删除
        deleteFun(row) {
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let data = {}
                this.$post(api + "/companyShow/delete/" + row, data).then(response => {
                    let res = response.data;
                    if (res.code == 0) {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.getListFun(1);
                    } else {
                        this.$message.error(res.desc);
                    }
                })
            }).catch(() => {

            });

        },
        //开启/关闭用户
        changeDemo(id, isUsed) {
            //true = 开启 false = 关闭
            let data = {}
            let uri = isUsed ? "enable" : "disable"
            let url = "/companyShow/" + uri + "/" + id;
            this.$post(api + url, data).then(response => {
                let res = response.data;
                if (res.code == 0) {
                    this.getListFun(this.pageNum);
                } else {
                    this.$message.error(res.desc);
                }
            })
        },
        //特定pageNum查询列表
        getListFun(val) {
            this.pageNum = val;
            this.getList();
        },

        //更换pageSize
        changSizeFun(val) {
            console.log(`每页 ${val} 条`);
            this.getListFun(val);
        },
        //翻页
        changpageFun(val) {
            console.log(this.pageNum);
            this.getListFun(val);
        },
        iconBeforeUpload(file) {
            var img = file.name.substring(file.name.lastIndexOf('.') + 1)
            const suffix = img === 'jpg'
            const suffix2 = img === 'png'
            const suffix3 = img === 'jpeg'
            // const isLt1M = file.size / 1024 / 1024 < 1;
            if (!suffix && !suffix2 && !suffix3) {
                this.$message.error("只能上传图片！");
                return false
            }
            // 可以限制图片的大小
            // if (!isLt1M) {
            //     this.$message.error('上传图片大小不能超过 1MB!');
            // }
            return suffix || suffix2 || suffix3
        },
        iconSuccess(response, file, fileList) {
            this.formDate.coverURL = response.data.fullUrl;
            this.formDate.coverURLList = [{
                uid: response.data.fullUrl,
                url: response.data.fullUrl
            }];
        },
        iconRemove() {
            this.formDate.coverURL = '';
            this.formDate.coverURLList = [];
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/company/CompanyShow/CompanyShow.vue